import '../../css/media.css';

const Media = () => {

    return (
        <div className="media-container">
            <div className="media-title">
                Learn more about my home through these local news stories!
            </div>
                    <a className="media-link" href="https://www.centraltexasgardener.org/2024/02/artistic-collaboration-goes-with-the-flow/">
                    Central Texas Gardner - Artistic Collaboration Goes with the Flow
                    </a>
                    <a className="media-link" href="https://www.pbs.org/video/artistic-collaboration-goes-with-the-flow-woymsa/">
                    Central Texas Gardner - Interview With My Pet Human!
                    </a>
                    <a className="media-link" href="https://www.austinhomemag.com/how-south-austins-octopus-house-went-from-modern-to-magic/">
                    Austin Home Magazine - How South Austin’s Octopus House Went from Modern to Magic
                    </a>
                    <a className="media-link" href="https://www.alexandermarchant.com/project/octopus-house/">
                    Alexander Marchant - OCTOPUS HOUSE
                    </a>
                    <a className="media-link" href="https://www.youtube.com/watch?v=zBvw--n2rPA">
                    Austin Community Capital - Octopus House: My Pet Human's Love Letter to Austin
                    </a>

                    {/* <a className="media-link" href="https://www.centraltexasgardener.org/2024/02/artistic-collaboration-goes-with-the-flow/">
                    </a>
                    <a className="media-link" href="https://www.centraltexasgardener.org/2024/02/artistic-collaboration-goes-with-the-flow/">
                    </a>
                    <a className="media-link" href="https://www.centraltexasgardener.org/2024/02/artistic-collaboration-goes-with-the-flow/">
                    </a>
                    <a className="media-link" href="https://www.centraltexasgardener.org/2024/02/artistic-collaboration-goes-with-the-flow/">
                    </a> */}
        </div>
    )
}

export default Media;